import { useCallback, ReactNode, ReactElement } from 'react';
import {
  CheckboxContainerSt,
  CheckboxLabelSt,
  CheckboxSt,
  CheckboxBackgroundSt,
} from './Checkbox.css';

export interface ICheckboxProps {
  name: string;
  qaID?: string;
  label?: string | ReactNode;
  checked?: boolean;
  disabled?: boolean;
  danger?: boolean;
  onChange?: Function;
  squareSelect?: boolean;
  info?: string | ReactNode;
  className?: string;
  alignment?: 'self-start' | 'center';
}

const Checkbox = ({
  name,
  label = '',
  checked = false,
  disabled = false,
  danger = false,
  onChange,
  qaID,
  squareSelect = false,
  info,
  className,
  alignment = 'center',
}: ICheckboxProps): ReactElement => {
  const handleCheckboxChange = useCallback(() => {
    if (onChange) {
      onChange(checked);
    }
  }, [checked, onChange]);

  return (
    <CheckboxContainerSt
      className={className}
      htmlFor={name}
      disabled={disabled}
      alignment={alignment}
    >
      <CheckboxSt
        id={name}
        role="checkbox"
        type="checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
        disabled={disabled}
      />
      <CheckboxBackgroundSt
        data-qa={qaID}
        selected={checked}
        squareSelect={squareSelect}
        disabled={disabled}
        danger={danger}
        className="checkbox"
      />
      <CheckboxLabelSt disabled={disabled} danger={danger} className="label">
        {label}
      </CheckboxLabelSt>
      {info}
    </CheckboxContainerSt>
  );
};
export default Checkbox;
